<template>
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M18.364 5.364L5.636 18.092M18.364 18.092L5.636 5.364"
    />
  </svg>
</template>
